<template>
  <div class="menu-button-container">
    <div v-for="menu in menus" :key="menu.key">
      <va-button @click.prevent="menuChange(menu.key)" :type="menu.key === menuActive ? 'primary' : 'subtle'" size="md">{{menu.name}}</va-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      required: true,
    },
    menuActive: {
      type: Number,
      required: true,
    },
  },
  methods: {
    menuChange(key) {
      this.$emit('menu-change', key)
    },
  },
}
</script>

<style lang="scss">
.menu-button-container {
  display: flex;
  flex-direction: row;
  gap: 12px;
}
</style>
